// Helper functions to standardize Medical Chronology analytics tracking
// All functions hide boilerplate such as suppressing property inheritance
// and common Medical-Chronology-specific payload fields.

import { AnalyticsEvent } from '@/analytics/schema/events.schema'
import { getTrackEventGlobal } from '@/analytics/utils/analytics-helpers'
import type { TrackEventFn } from '@/analytics/hooks/useAnalytics'

/**
 * Track a Medical Chronology specific analytics event.
 * Automatically applies { suppressFeatureInheritance: true } so that no
 * residual properties from previous events leak into this payload.
 */
export function trackMedChronEvent(
  event: AnalyticsEvent,
  props: Record<string, string | number | boolean>,
  track: TrackEventFn | undefined = getTrackEventGlobal()
) {
  if (!track) return
  track(event, props, {
    suppressFeatureInheritance: true,
  })
}
